import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

export const CartContext = React.createContext();

function CartProvider(props) {
    const [cart_item, set_cart_item] = useState(0);
    function checkCartItem() {
        axios
            .get(`${process.env.REACT_APP_BACKEND_API}/cart`, {
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            })
            .then((res) => {
                set_cart_item(res.data.length);
            })
            .catch((err) => {
                console.log(err);
            });
    }
    return (
        <CartContext.Provider
            value={{
                cart_item,
                checkCartItem,
            }}
        >
            {props.children}
        </CartContext.Provider>
    );
}
export default CartProvider;
